import React, { useContext } from 'react';

import { connectStateResults } from 'react-instantsearch-dom';
import { Card, Skeleton, Image, Empty } from 'antd';

import PostersView from '../PostersView';
import { ReactComponent as Session } from 'assets/icons/session.svg';
import { ViewContext } from '../ViewContext';
import { VIEW } from 'constants.js';

const StateResults = ({ searchResults, loading }) => {
	const { view } = useContext(ViewContext);
	const searchLoading = loading || !searchResults;

	if (searchLoading)
		return (
			<section className="poster-grid">
				{[...Array(8)].map((_, index) => (
					<Card key={index} className="gx-mb-0 -shadow-1">
						<Image
							className="card-image"
							style={{ height: '7em' }}
							alt="placeholder"
							src={require('assets/images/placeholder.png')}
						/>
						<Skeleton active paragraph={{ rows: 5 }}></Skeleton>
					</Card>
				))}
			</section>
		);
	if (searchResults.nbHits === 0) return <Empty style={{ margin: '20em 0' }} />;

	return (
		<section className="">
			{view !== VIEW.QUICK && (
				<p>
					showing {searchResults.hits.length} out of {searchResults.nbHits} results
				</p>
			)}
			{searchResults.hits.map((sessionPoster, index) => (
				<Card
					title={
						<div className="gx-d-flex">
							<h2 className="gx-text-white gx-mb-0 gx-font-weight-semi-bold">
								{sessionPoster.session.title}
							</h2>
							<Session
								className="gx-ml-auto gx-pl-3"
								style={{ flexShrink: 0, flexBasis: '2.75rem' }}
							/>
						</div>
					}
					className="author-card"
					key={index}
				>
					<PostersView posters={sessionPoster.posters} />
				</Card>
			))}
		</section>
	);
};

export default connectStateResults(StateResults);
